// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IBBoxSchema } from '../bbox/BBoxSchema';
import type { IClusterSchema } from '../cluster/ClusterSchema';
import type { INewbuildingPolygonSchema } from '../newbuilding_polygon/NewbuildingPolygonSchema';

export interface IV1GetClustersForMapResponseSchema {
  /** Координаты области, описывающей объявления **/
  bbox?: IBBoxSchema;
  /** Тип кластеров **/
  clustersType?: EClustersType;
  /** Кластера расширенной выдачи **/
  extended?: IClusterSchema[];
  /** json-query расширенного запроса **/
  extendedJsonQuery?: object;
  /** query-строка расширенного запроса **/
  extendedQueryString?: string;
  /** Кластера объявлений **/
  filtered?: IClusterSchema[];
  /** Запрос по новостройкам **/
  isNewobject: boolean;
  /** Признак того, что эксперимент пульсирующих пинов включен **/
  isPromotionTopPulsedGlowEnabled?: boolean;
  /** json-query запроса **/
  jsonQuery: object;
  /** ML GUID поисковой сессии **/
  mlSearchSessionGuid?: string;
  /** Список полигонов для ЖК **/
  newbuildingsPolygons: INewbuildingPolygonSchema[];
  /** query-строка запроса без учета гео **/
  nonGeoQueryString: string;
  /** Кол-во объявлений **/
  offersCount?: number;
  /** Точность кластеров **/
  precision?: number;
  /** query-строка запроса **/
  queryString: string;
}

export enum EClustersType {
  /** Расхлопнутый кластер с детальной информацией. **/
  'Detailed' = 'detailed',
  /** Кластер горошком с возможностью открыть результаты выдачи. **/
  'OpenablePeas' = 'openablePeas',
  /** Кластер горошком. **/
  'Peas' = 'peas',
}
